import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "max-width-button" }
const _hoisted_3 = { style: {"position":"absolute","bottom":"0.5rem","font-size":".8em","font-style":"italic"} }

import { IonGrid, IonRow, IonLabel, IonButton, IonSelect, IonSelectOption, IonItem, useIonRouter } from '@ionic/vue';
import { onMounted, ref } from 'vue';
import { Storage } from '@ionic/storage';
import { version } from '@/../lib/version'
import { useI18n } from 'vue-i18n';

type detectionService = {
    plateLocation: string, 
    toDetectMakeAndModel: boolean | undefined
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PreferencesPage',
  setup(__props) {

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})


const storage = new Storage();
const router = useIonRouter();
const loaded = ref<boolean>(false)

// When the app enters de page, it will get the stored values
// for the plate location, detection type
onMounted(() => {
    storage.create().then(() => {
        Promise.all([
            storage.get("plateLocation").then((plateLocation: string) => {
                photo.value.plateLocation = plateLocation;
            }),
            storage.get("detect").then((toDetect: boolean) => {
                photo.value.toDetectMakeAndModel = toDetect;
            }),
        ]).then(() => {
            loaded.value = true;
        });
    });
});


const photo = ref<detectionService>({
    plateLocation: "eu",
    toDetectMakeAndModel: undefined
});

async function confirmPreferences(){
    await storage.create();
    storage.set('plateLocation', photo.value.plateLocation);
    storage.set('detect', photo.value.toDetectMakeAndModel);
    router.push({name:'homepage'});
}


return (_ctx: any,_cache: any) => {
  return (loaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonItem), {
          style: {"margin-top":"1rem"},
          class: "bradius12"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('preferencesPage.where')), 1),
                _createVNode(_unref(IonSelect), {
                  interface: "popover",
                  modelValue: photo.value.plateLocation,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((photo.value.plateLocation) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonSelectOption), { value: "eu" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.eu')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelectOption), { value: "na" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.na')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelectOption), { value: "ca" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.ca')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelectOption), { value: "sa" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.sa')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonSelectOption), { value: "other" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.other')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonItem), { class: "bradius12 margin-1-rem-tb" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonGrid), {
              fixed: true,
              style: {"padding":"1rem 0"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonLabel), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('preferencesPage.licenseOption')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), { style: {"padding":"1rem 0 0.5rem"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), {
                      expand: "block",
                      class: "customButton",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (photo.value.toDetectMakeAndModel = false)),
                      color: !photo.value.toDetectMakeAndModel? 'primary' : 'light'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_unref(t)('preferencesPage.plateOnly')), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonRow), { style: {"padding":"0.5rem 0 0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), {
                      expand: "block",
                      class: "customButton",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (photo.value.toDetectMakeAndModel = true)),
                      color: photo.value.toDetectMakeAndModel? 'primary' : 'light'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_unref(t)('preferencesPage.plateAndVehicle')), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonButton), {
            shape: "round",
            size: "large",
            expand: "block",
            onClick: confirmPreferences
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('preferencesPage.confirm')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('version')) + " " + _toDisplayString(_unref(version)), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})